module.exports = __webpack_public_path__ + "static/media/our_story_img.60eac94f.svg";